import React from 'react';
import './AnimatedButton.scss';

const AnimatedButton = ({ text, theme, activeClass, clickHandler, extClasses, itemData }) => {
  function handleButtonClick(e) {
    if (!extClasses?.includes('modal-ask-question')) {
      e.stopPropagation();
      clickHandler && clickHandler(e, itemData);
    }
  }

  return (
    <button
      className={`animated_button ${activeClass} ${theme} ${extClasses}`}
      onClick={handleButtonClick}>
      {text}
    </button>
  );
};

export default AnimatedButton;
